import { useEffect, useState, useMemo } from 'react'

export const useSingleSelector = (items = [], reverse = false) => {
    const [selection, setSelection] = useState([])
    const [selected, setSelected] = useState(null)

    const itemsKey = useMemo(() => JSON.stringify(items), [JSON.stringify(items)])

    useEffect(() => { setItems(items, reverse) }, [itemsKey, reverse])

    const setItems = (items_ = [], reverse = false) => {
        let newSelection = []
        for (let i = 0; i < items_.length; i++)
            newSelection.push({id: items_[i].id, label: items_[i].label})

        if (reverse) setSelection(newSelection.reverse())
        else setSelection(newSelection)
    }

    const computeSelection = (newSelection = null) => {
        setSelected(newSelection)
    }

    const onSelect = (event) => {
        const target = event.target.value ?? null
        if (!target) return
        setSelected(target)
    }

    return { selection, computeSelection, selected, onSelect, setItems }
}